import { render, staticRenderFns } from "./activiti-deployment.vue?vue&type=template&id=9533e39a&scoped=true"
import script from "./activiti-deployment.vue?vue&type=script&lang=js"
export * from "./activiti-deployment.vue?vue&type=script&lang=js"
import style0 from "./activiti-deployment.vue?vue&type=style&index=0&id=9533e39a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9533e39a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9533e39a')) {
      api.createRecord('9533e39a', component.options)
    } else {
      api.reload('9533e39a', component.options)
    }
    module.hot.accept("./activiti-deployment.vue?vue&type=template&id=9533e39a&scoped=true", function () {
      api.rerender('9533e39a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/system/activiti/activiti-deployment.vue"
export default component.exports